export default {
  INVOICES: "INVOICES",
  CONTRACTS: "CONTRACTS",
  SPOTIFY_EXPORT: "SPOTIFY_EXPORT",
  EVENT_TEMPLATES: "EVENT_TEMPLATES"
};